import Thumbnails from "./Thumbnails/index";
import Slideshow from "./SlideShow/Fetcher";

export default {
  Thumbnails,
  Slideshow
};
